module.exports = __webpack_public_path__ + "img/5.825a3e6f.jpg";